module.exports = __webpack_public_path__ + "img/zalo.9087cf4a.svg";